import React from 'react'
import Honeybadger from 'honeybadger-js'

// data
import { useAppSettings } from 'components/shared/SettingsProvider'

// local components
import UI from './UI'

class AppErrorBoundaryClass extends React.Component {
  constructor(props) {
    super(props)
    const { honeybadgerApiKey, environment } = props.appSettings

    this.state = { error: null }
    Honeybadger.configure({
      apiKey: honeybadgerApiKey,
      environment: environment,
      disabled: environment === 'local'
    })
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, errorInfo) {
    console.log('AppErrorBoundary', error, errorInfo)
    Honeybadger.notify(error, {
      name: 'AppErrorBoundary',
      context: { errorInfo }
    })
  }

  render() {
    if (this.state.error) {
      return <UI error={this.state.error} />
    }
    return this.props.children
  }
}

function AppErrorBoundary(props) {
  const appSettings = useAppSettings()

  return <AppErrorBoundaryClass {...props} appSettings={appSettings} />
}

export default AppErrorBoundary
